// Native
import { useState } from "react"
import { useNavigate } from "react-router"

// Components
import { Button, ButtonGroup, Td, useDisclosure } from "@chakra-ui/react"
import { Container, Dash, Dev, Heading, Icon, IconButton, Profile, Row, Searchable, Table } from "components"

// Config
import { Moment, Mask } from "config"

// Hooks
import { useEmployees } from "hooks"

// Screens
import Register from "./register"

export default function Employees(){

    const navigate = useNavigate()
    const [ page, setPage ] = useState(1)
    const [ term, setTerm ] = useState('')
    const employees = useEmployees(page, term)
    const register = useDisclosure()

    const columns = [
        { children: 'Nome' },
        { children: 'Cargo/Função' },
        { children: 'E-mail' },
        { children: 'Visto', isNumeric: true },
        { children: 'Cadastro', isNumeric: true }
    ]

    return(
    <>
    <Container mt={10}>
        
        <Heading title="Funcionários">
            <ButtonGroup size="xs" isDisabled={employees.isFetching}>
                <Button children="Funcionário" leftIcon={<Icon name="add" />} colorScheme="orange" onClick={register.onOpen} />
                <IconButton label="Atualizar" icon="refresh" isLoading={employees.isFetching} onClick={employees.refetch} />
                <Dev data={employees.data} />
            </ButtonGroup>
        </Heading>

        <Searchable value={term} setValue={setTerm} placeholder="Pesquisar por Nome, Email ou CPF..." />

        <Table columns={columns} meta={employees.data?.meta} loading={employees.isLoading} setPage={setPage}>
            { employees.data?.data?.map(item => <Item key={item.id} data={item} onClick={() => navigate(`/employees/${item.id}`)} />)}
        </Table>
    </Container>

    <Register {...register} onSuccess={employees.refetch} />
    </>
    )
}

const Item = ({ data, ...props }) => (
    <Row {...props}>
        <Td><Profile name={data.name} src={data.avatar_url} /></Td>
        <Td children={data.tagline} />
        <Td children={data.email} />
        <Td isNumeric children={<Dash children={data.last_access && Moment(data.last_access).calendar()} />} />
        <Td isNumeric children={<Dash children={data.created_at && Moment(data.created_at).calendar()} />} />
    </Row>
)